module.exports = __webpack_public_path__ + "img/mm-profile-dummy-female@3x.5ccdb59f.png";